import { useEffect, useRef } from "react";
import { insertImagePreloadLink } from "../utils/insertImagePreloadLink";
export const usePreloadImage = (imgUrl) => {
    const cleanupRef = useRef(null);
    if (imgUrl) {
        if (cleanupRef.current) {
            cleanupRef.current();
        }
        cleanupRef.current = insertImagePreloadLink(imgUrl);
    }
    useEffect(() => () => {
        if (cleanupRef.current) {
            cleanupRef.current();
            cleanupRef.current = null;
        }
    }, [imgUrl]);
};
